module.exports = __webpack_public_path__ + "img/whitecircle.ce8cd010.svg";